export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10746.a75403c8.jpg";